<template>
  <div class="decorate">
    <div class="cricle1"></div>
    <div class="cricle2"></div>
    <div class="cricle3"></div>
    <div class="cricle4"></div>
  </div>
</template>

<script>
export default {};
</script>

<style>
</style>